import React, { useEffect, useState } from "react";
import {
  convertBytestoMb,
  convertDate,
  getConfiguredLabel,
  renderFileIconClass,
  renderGroupIcon,
  renderSourceTypeIconClass,
} from "../../common/commonHelper";
import { getAssignedUserCount } from "../../store/rolesData/getRolesdata";
import { useDispatch } from "react-redux";
import {
  activeText,
  adminPage,
  inactiveText,
} from "../../common/labelConstants";
import { getDocFormatGraphInfo } from "../../store/documents/documentSlice";
import { DataListTemplates } from "../../common/constants";

export const DataTemplateTypes = {
  docImageAndData: "docImageAndData",
  formatDate: "formatDate",
  formatSize: "formatSize",
  addFileTypeImage: "addFileTypeImage",
  createdByIcon: "createdByIcon",
  userActionsSelfEdit: "userActionsSelfEdit",
  activeInactive: "activeInactive",
  keyValue: "keyValue",
  assignedUsers: "assignedUsers",
  uploadedDocs: "uploadedDocs",
  secureString: "secureString",
  sourceTypeImageAndData: "sourceTypeImageAndData",
  metadata_tag: "metadata_tag",
  
};

export const AssignedUserCount = (props) => {
  const dispatch = useDispatch();
  const [count, setCount] = useState("");
  const getAssignedUserInfo = (roleName) => {
    dispatch(getAssignedUserCount({ roleName: roleName })).then((res) => {
      if (res.payload.status === 200) {
        setCount(res.payload.data || 0);
      }
    });
  };
  useEffect(() => {
    getAssignedUserInfo(props.roleName);
  }, []);

  return <span>{count}</span>;
};

export const DocsCount = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  useEffect(()=>{
    const fetchData = async () => {
    dispatch(
      getDocFormatGraphInfo({
        template: DataListTemplates.allDocuments,
        filter: "sourceName",
      })
    ).then((res) => {
      const result = res?.payload?.data.data || {};
      if (Array.isArray(result)) {
        if (result.length === 0) {
        } else {
          setData(result);
        }
      }
    });
  };
  fetchData()
  },[])

  let count = data.find(obj => obj._id === props.sourceName)?.count;
  if(count===undefined)
  {
    count=0;
  }

  return <span>{count}</span>;
};

export function RenderDataTemplate(index, item, rowData, setShowVersionListingPopup, fromPopup) {
  const value =  rowData['metadata'] && rowData['metadata'][item?.field] ? rowData['metadata'][item.field].key : rowData[item.field];
  const handleCreadtedBy = (createdBy) => {
    let crt = "";
    if (createdBy > "")
      crt = createdBy.split(" ").map((item) => item.charAt(0));
    return crt;
  }

  switch (item.template) {
    case DataTemplateTypes.docImageAndData:
      return (
        <React.Fragment>
          <span className="document_col" onClick={()=>{
              if(typeof setShowVersionListingPopup == 'function'){
                setShowVersionListingPopup(rowData)
              }
            }}>
            <span className="icon icon_img">
              <span
                className={renderFileIconClass(rowData.fileExtension)}
              ></span>
            </span>
            <span className="docName">{value}</span>
            <span className={(fromPopup && index.rowIndex==0)?"rc_current_status":""}>
              {!fromPopup && renderGroupIcon(rowData.fileAccessibility)}
            </span>
          </span>
        </React.Fragment>
      );
    case DataTemplateTypes.addFileTypeImage:
      return (
        <React.Fragment>
          <span className="icon">
            <span className={renderFileIconClass(rowData.fileExtension)}></span>
          </span>
        </React.Fragment>
      );
    case DataTemplateTypes.createdByIcon:
      return (
        <React.Fragment>
          <span className="DisFlex rc_user_circleName">
            <span className="icon user_icon">{handleCreadtedBy(value)}</span>
            <span className="icon user_text">{value}</span>
          </span>
        </React.Fragment>
      );
    case DataTemplateTypes.formatDate:
      return <> {convertDate(value, item.format)} </>;
    case DataTemplateTypes.formatSize:
      return <>{convertBytestoMb(value, item.format)}</>;
    case DataTemplateTypes.activeInactive: {
      const activeInactive =
        value === true ? (
          <span className="statusActive">
            {getConfiguredLabel(adminPage, activeText)}
          </span>
        ) : (
          <span className="statusInactive">
            {getConfiguredLabel(adminPage, inactiveText)}
          </span>
        );
      return activeInactive;
    }
    case DataTemplateTypes.keyValue:
      return (value || {}).key;

    case DataTemplateTypes.uploadedDocs:
      return (
        <DocsCount
          sourceName={rowData.sourceName}
        ></DocsCount>
      );
    case DataTemplateTypes.assignedUsers:
      return (
        <AssignedUserCount roleName={rowData.roleName}></AssignedUserCount>
      );
    case DataTemplateTypes.secureString:
      return <span>**********</span>;

    case DataTemplateTypes.sourceTypeImageAndData:
      return (
        <React.Fragment>
          <span className="slb_file_source_icon_main">
            <span className="slb_file_source_icon icon_image">
              <span
                className={renderSourceTypeIconClass(rowData.sourceType)}
              ></span>
            </span>
            <span className="slb_file_sourceName">{value}</span>
          </span>
        </React.Fragment>
      );
    case DataTemplateTypes.metadata_tag:
        return (
          <div className="rc_ellipsis_items">{value}</div>
        );
    default: {
      if (typeof value === "object") {
        return null;
      } else {
        return  <p>{value}</p>;
      }
    }
  }
}
